import { LayoutHOC } from 'base/ui/layout/layout';
import createRoutingOrTransfer from '.';

export const createRoutingOrTransferPage = (layoutHOC: LayoutHOC) => {
  return layoutHOC(createRoutingOrTransfer());
};
